(function () {
  if (window.abPdp !== 'B') return;
  var CELLS = 70;
  var SIZE = 560;
  var STASH = 'pf_preview';

  function track(name) {
    try { if (window.gtag) gtag('event', name, { ab_pdp: 'B' }); } catch (e) {}
  }

  function tone(v) {
    v = (v - 128) * 1.12 + 136;
    return Math.max(0, Math.min(255, Math.round(v / 20) * 20));
  }

  function squareOf(img) {
    var w = img.naturalWidth || img.width, h = img.naturalHeight || img.height;
    var s = Math.min(w, h);
    var sq = document.createElement('canvas');
    sq.width = sq.height = SIZE;
    sq.getContext('2d').drawImage(img, (w - s) / 2, (h - s) * 0.35, s, s, 0, 0, SIZE, SIZE);
    return sq;
  }

  function stitch(square, cells) {
    var small = document.createElement('canvas');
    small.width = small.height = cells;
    var sctx = small.getContext('2d');
    sctx.imageSmoothingQuality = 'high';
    sctx.drawImage(square, 0, 0, cells, cells);
    var px = sctx.getImageData(0, 0, cells, cells).data;
    var out = document.createElement('canvas');
    out.width = out.height = SIZE;
    var ctx = out.getContext('2d');
    var c = SIZE / cells;
    ctx.lineCap = 'round';
    ctx.lineWidth = c * 0.34;
    for (var y = 0; y < cells; y++) {
      for (var x = 0; x < cells; x++) {
        var i = (y * cells + x) * 4;
        var r = tone(px[i]), g = tone(px[i + 1]), b = tone(px[i + 2]);
        ctx.fillStyle = 'rgb(' + r * 0.8 + ',' + g * 0.8 + ',' + b * 0.8 + ')';
        ctx.fillRect(x * c, y * c, c + 0.5, c + 0.5);
        var x0 = x * c + c * 0.2, y0 = y * c + c * 0.2, x1 = (x + 1) * c - c * 0.2, y1 = (y + 1) * c - c * 0.2;
        ctx.strokeStyle = 'rgb(' + r * 0.92 + ',' + g * 0.92 + ',' + b * 0.92 + ')';
        ctx.beginPath(); ctx.moveTo(x0, y1); ctx.lineTo(x1, y0); ctx.stroke();
        ctx.strokeStyle = 'rgb(' + Math.min(255, r * 1.08 + 10) + ',' + Math.min(255, g * 1.08 + 10) + ',' + Math.min(255, b * 1.08 + 10) + ')';
        ctx.beginPath(); ctx.moveTo(x0, y0); ctx.lineTo(x1, y1); ctx.stroke();
      }
    }
    return out;
  }

  function mount(hoop, node) {
    var old = hoop.querySelector('canvas, img');
    if (old) old.remove();
    hoop.appendChild(node);
    hoop.classList.add('has-photo');
  }

  function clear(hoop) {
    var old = hoop.querySelector('canvas, img');
    if (old) old.remove();
    hoop.classList.remove('has-photo');
  }

  function plain(hoop, src) {
    var im = new Image();
    im.alt = '';
    im.src = src;
    mount(hoop, im);
  }

  function reveal(hoop, img, opts) {
    opts = opts || {};
    var square, stitched;
    try {
      square = squareOf(img);
      stitched = stitch(square, opts.cells || CELLS);
      stitched.getContext('2d').getImageData(0, 0, 1, 1);
    } catch (e) { plain(hoop, img.src); return null; }
    var canvas = document.createElement('canvas');
    canvas.width = canvas.height = SIZE;
    var ctx = canvas.getContext('2d');
    mount(hoop, canvas);
    var still = opts.still || window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (still) { ctx.drawImage(stitched, 0, 0); return stitched; }
    var start = null, HOLD = 500, SWEEP = 1700;
    function frame(t) {
      if (start === null) start = t;
      var p = Math.min(1, Math.max(0, (t - start - HOLD) / SWEEP));
      var e = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
      var seam = e * SIZE;
      ctx.drawImage(square, 0, 0);
      if (seam > 0) ctx.drawImage(stitched, 0, 0, seam, SIZE, 0, 0, seam, SIZE);
      if (p > 0 && p < 1) {
        ctx.save();
        ctx.shadowColor = '#e2b84a';
        ctx.shadowBlur = 18;
        ctx.fillStyle = '#e2b84a';
        ctx.fillRect(seam - 2, 0, 4, SIZE);
        ctx.restore();
      }
      if (p < 1) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
    return stitched;
  }

  function load(src, cors, done, fail) {
    var img = new Image();
    if (cors) img.crossOrigin = 'anonymous';
    img.onload = function () { done(img); };
    img.onerror = fail || function () {};
    img.src = src;
  }

  function initEntry(entry) {
    var card = entry.querySelector('.pf-entry__card');
    var hoop = entry.querySelector('.pf-hoop');
    var input = entry.querySelector('input[type="file"]');
    if (!card || !hoop || !input) return;
    entry.querySelectorAll('[data-pf-pick]').forEach(function (b) {
      b.addEventListener('click', function () { input.click(); track('ab_pdp_entry_choose'); });
    });
    input.addEventListener('change', function () {
      var file = input.files && input.files[0];
      if (!file) return;
      var url = URL.createObjectURL(file);
      load(url, false, function (img) {
        card.classList.add('is-stitched');
        var stitched = reveal(hoop, img);
        track('ab_pdp_entry_preview');
        try { if (stitched) sessionStorage.setItem(STASH, stitched.toDataURL('image/jpeg', 0.8)); } catch (e) {}
        card.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  }

  function initCartHoops(root) {
    (root || document).querySelectorAll('.pf-hoop[data-pf-src]:not([data-pf-done])').forEach(function (hoop) {
      hoop.setAttribute('data-pf-done', '1');
      var src = hoop.getAttribute('data-pf-src');
      load(src, true, function (img) { reveal(hoop, img, { still: true, cells: 44 }); }, function () { plain(hoop, src); });
    });
  }

  function initReadMore() {
    var desc = document.querySelector('.collection-hero__description');
    if (!desc || desc.scrollHeight < 220) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'pf-readmore pf-change';
    btn.textContent = 'Read more';
    btn.addEventListener('click', function () { desc.classList.add('is-open'); btn.remove(); });
    desc.insertAdjacentElement('afterend', btn);
  }

  window.pfHoop = { reveal: reveal, plain: plain, clear: clear, load: load, track: track, STASH: STASH };

  function init() {
    document.querySelectorAll('.pf-entry').forEach(initEntry);
    initCartHoops();
    initReadMore();
    new MutationObserver(function () { initCartHoops(); }).observe(document.body, { childList: true, subtree: true });
    document.dispatchEvent(new CustomEvent('pf:ready'));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
